import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Fc301d06243114f54ad9f33e7b35de97d@o156557.ingest.sentry.io\u002F6140188",
    environment:"prod",
    release:"c97382280778e66ffb94302f09c7a70db6326efd",
    extra:{"url":"https:\u002F\u002Fwww.californiaoliveranch.com","deploy_url":"https:\u002F\u002F68083b9e16dac30008f773f8--cor-prod.netlify.app"},
    allowUrls:["https:\u002F\u002Fwww.californiaoliveranch.com"],
    ignoreErrors:["[deprecation]","[intervention]","[csp-violation]"]
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe(),
    new ExtraErrorData(),
    new ReportingObserver(),
    new RewriteFrames(),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
